module.exports = __webpack_public_path__ + "static/img/add-room.18dfb1a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add-room.svg
// module id = p4FP
// module chunks = 1